// NOTE: At the time of writing, `notifee` does not support the web platform

export const notifee = null;
